// Mobile Buy Now Button Animation - Anti-Flicker Fixed Version
(function() {
  'use strict';
  
  // Global state management
  let isInitialized = false;
  let animationIntervals = new Map();
  let isAnimationEnabled = false;
  
  // Debounce helper
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Device detection
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
           window.innerWidth <= 768;
  }

  function hasHoverSupport() {
    return window.matchMedia && window.matchMedia('(hover: hover)').matches;
  }

  // Clean up all animations and reset buttons
  function cleanup() {
    // Clear all intervals
    animationIntervals.forEach(interval => clearInterval(interval));
    animationIntervals.clear();
    
    // Reset all buttons to normal state
    const buttons = document.querySelectorAll('.shopify-payment-button__button');
    buttons.forEach(button => {
      const arrowBox = button.querySelector('.buy-now-arrow-box');
      const arrowsContainer = button.querySelector('.arrows-container');
      const text = button.querySelector('.buy-now-text');
      
      if (arrowBox && arrowsContainer && text) {
        // Remove all mobile classes
        arrowBox.classList.remove('mobile-expanded');
        arrowsContainer.classList.remove('mobile-expanded');
        text.classList.remove('mobile-hidden');
        button.classList.remove('mobile-animation-loading');
      }
    });
    
    isInitialized = false;
    isAnimationEnabled = false;
  }

  // Main animation function
  function initMobileAnimation() {
    // Prevent multiple initializations
    if (isInitialized) {
      return;
    }
    
    // Check if we should run on this device
    if (!isMobileDevice() || hasHoverSupport()) {
      return;
    }

    const buttons = document.querySelectorAll('.shopify-payment-button__button');
    
    if (buttons.length === 0) {
      return;
    }

    // Mark as initialized early to prevent race conditions
    isInitialized = true;

    buttons.forEach((button, index) => {
      const arrowBox = button.querySelector('.buy-now-arrow-box');
      const arrowsContainer = button.querySelector('.arrows-container');
      const text = button.querySelector('.buy-now-text');

      if (!arrowBox || !arrowsContainer || !text) {
        return;
      }

      // Add loading class to prevent initial flicker
      button.classList.add('mobile-animation-loading');
      
      // Create unique identifier for this button
      const buttonId = `button-${index}`;
      let isExpanded = false;

      function toggleExpansion() {
        if (!isAnimationEnabled) return;
        
        if (isExpanded) {
          // Contract to normal state
          arrowBox.classList.remove('mobile-expanded');
          arrowsContainer.classList.remove('mobile-expanded');
          text.classList.remove('mobile-hidden');
          isExpanded = false;
        } else {
          // Expand
          arrowBox.classList.add('mobile-expanded');
          arrowsContainer.classList.add('mobile-expanded');
          text.classList.add('mobile-hidden');
          isExpanded = true;
        }
      }

      function runAnimationCycle() {
        if (!isAnimationEnabled) return;
        
        // Expand at 450ms
        const timeout1 = setTimeout(() => {
          if (isAnimationEnabled && !isExpanded) {
            toggleExpansion();
          }
        }, 450);

        // Contract at 1800ms
        const timeout2 = setTimeout(() => {
          if (isAnimationEnabled && isExpanded) {
            toggleExpansion();
          }
        }, 1800);
      }

      // Store interval for cleanup
      const interval = setInterval(() => {
        if (isAnimationEnabled) {
          runAnimationCycle();
        }
      }, 3000);
      
      animationIntervals.set(buttonId, interval);
      
      // Enable animations after a short delay to prevent flicker
      setTimeout(() => {
        button.classList.remove('mobile-animation-loading');
        isAnimationEnabled = true;
        
        // Start first cycle after transitions are enabled
        setTimeout(runAnimationCycle, 100);
      }, 300);
    });
  }

  // Safe initialization with proper timing
  function safeInit() {
    // Clean up any existing animations first
    cleanup();
    
    // Wait for any ongoing transitions to complete
    setTimeout(() => {
      initMobileAnimation();
    }, 100);
  }

  // Debounced resize handler
  const debouncedResize = debounce(() => {
    safeInit();
  }, 500);

  // Debounced visibility change handler  
  const debouncedVisibilityChange = debounce(() => {
    if (document.visibilityState === 'visible') {
      safeInit();
    } else {
      cleanup();
    }
  }, 300);

  // Initialize based on page state
  function initialize() {
    if (document.readyState === 'complete') {
      setTimeout(safeInit, 100);
    } else {
      window.addEventListener('load', () => {
        setTimeout(safeInit, 100);
      }, { once: true });
    }
  }

  // Event listeners
  document.addEventListener('visibilitychange', debouncedVisibilityChange);
  window.addEventListener('resize', debouncedResize);
  
  // Handle page unload
  window.addEventListener('beforeunload', cleanup);

  // Start initialization
  initialize();

})();